import NavBar from "@/components/navigation/NavBar";
import Map from "@/components/navigation/Map";
import React, { useContext, useEffect, useRef, useState } from "react";
import ExposeCard from "@/components/Landingpage/ExposeCard";
import { FavoritesContext } from "@/lib/FavoritesContext";
import { ListIcon, MapIcon } from "../../public/svg/svg";
import { useFilterFetch } from "@/lib/useFilterFetch";
import { Skeleton } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import {
  ArrowTopRightIcon,
} from "@radix-ui/react-icons";
import { Toaster } from "sonner";
import { ScrollArea } from "@/components/ui/scroll-area";
import PropertyFilterBar from "@/components/navigation/FilterSearchBar";
import { IconSearch } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Motion/Reveal";

export default function ImmobilienangebotPage() {
  const { favorites, handleFavoriteToggle } = useContext(FavoritesContext);
  const [showMap, setShowMap] = useState(true);
  const [focusedEstateId, setFocusedEstateId] = useState(null);
  const scrollContainerRef = useRef(null);
  const [loading, setLoading] = useState(true);


  const estates = useFilterFetch({
    onStart: () => setLoading(true),
    onComplete: () => setLoading(false),
  });
  const toggleView = () => setShowMap(!showMap);

 
  // Handles estate click on the map
  const handleEstateClickOnMap = (estateId) => {
    setFocusedEstateId(estateId);

    scrollToExpose(estateId);
  };

 

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <div className="bg-white ">
      <Toaster position="top-right" />

      <NavBar className=" font-serif bg-white bg-opacity-80" />
      <div className=" md:px-5 border  rounded-b-2xl shadow-lg bg-gray-50 pt-16 md:pt-20 md:flex border-t gap-4 md:gap-0 border-b-2 items-center">
        <PropertyFilterBar />
      </div>

      <div className="flex w-full justify-between relative">
        <motion.button
          variants={variants}
          animate="visible"
          initial="hidden"
          transition={{ duration: 0.5 }}
          onClick={toggleView}
          className="z-30 sm:hidden shadow-xl px-1 py-1 bg-prime-900/90 text-white rounded-full fixed bottom-7 right-[calc(50%-5rem)]"
        >
          <motion.div 
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            className="rounded-full w-full h-full px-2 py-2 border-2 border-gray-300 shadow-lg">
          {!showMap ? (
            <div className="flex gap-2 items-center">
              <ListIcon className="size-6" /> Listenansicht
            </div>
          ) : (
            <div className="flex gap-2 items-center">
              <MapIcon className="size-6" /> Kartenansicht
            </div>
          )}
          </motion.div>
         
        </motion.button>

        <div
          id="left_side"
          className={`md:w-[90%]  bg-gray-100 pb-5 ${showMap ? 'hidden md:block' : 'block'} h-[calc(100vh-12.8rem)] md:h-[calc(100vh-11.1rem)] overflow-hidden`}
        >
          {estates.length === 0 && !loading ? (
            <div className="flex flex-col justify-start items-start px-2 h-full">
              <p className="text-gray-600 py-10 px-5">
                Keine Ergebnisse gefunden
              </p>
              <motion.div
                variants={variants}
                animate="visible"
                initial="hidden"
                transition={{ duration: 0.5 }}
                className="p-5 self-center shadow-lg bg-prime-50 rounded-md  md:w-[50vw]  h-"
              >
                <IconSearch className="h-7 w-7 text-prime-950/70 mb-3" />
                <h3 className="text-lg text-prime-950 font-medium">
                  Neue Angebote direkt ins Postfach
                </h3>
                <p className="text-sm  text-gray-600">
                Erstellen Sie jetzt Ihr persönliches Suchprofil, um keine neuen Immobilienangebote zu verpassen!
                </p>
                <Link to={"/immobilien/suchprofil-anlegen"}>
                <button className="mt-4 text-[16px] font-medium group/nav-card text-dark-200 w-full p-2 bg-gradient-to-r from-prime-100 to-prime-200 rounded-lg transition-all hover:shadow-lg hover:bg-gray-200  stroke-white text-pretty flex gap-2 justify-center items-center">
                Jetzt Suchprofil erstellen
                  <ArrowTopRightIcon className="stroke-prime-950 rotate-45 group-hover/nav-card:-rotate-0 transition-transform" />
                </button>
                </Link>
              </motion.div>
            </div>
          ) : (
            <ScrollArea
              ref={scrollContainerRef}
              className="relative h-full w-full px-2 md:px-5"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
              <style jsx>{`
                .scroll::-webkit-scrollbar {
                  display: none;
                }
              `}</style>

              {/* Headline Above Grid */}
              <div className="ml-2 pt-2   z-0">
                <h2 className="text-3xl font-serif font- text-slate-600 pt-2">
                  Immobilien im Angebot
                </h2>
                <p className="pb-2 text-gray-600">
                  {loading ? (
                    <span class="loading loading-dots loading-md"></span>
                  ) : (
                    `${estates.length} Ergebnisse`
                  )}
                </p>
              </div>

              {/* Grid for ExposeCard items */}
              <div className="grid z-40 md:pr-5  gap-4 grid-cols-1 lg:grid-cols-2">
                {loading
                  ? Array.from({ length: 6 }).map((_, index) => (
                      <Skeleton
                        key={index}
                        variant="rect"
                        width="100%"
                        height="19rem"
                        className="rounded-lg animate-pulse"
                        style={{ borderRadius: "0.5rem" }}
                      />
                    ))
                  : estates.map(
                      (estate, index) =>
                        estates && (
                          <motion.div
                            className={`pb-1 ${index === estates.length - 1 ? "pb-14" : ""}`}
                            transition={{
                              type: "easeOut",
                              staggerChildren: 0.1,
                            }}
                            animate={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: 50 }}
                            exit={{ opacity: 0, scale: 0.9, y: 0 }}
                          >
                            {" "}
                            <motion.div
                              whileHover={{ scale: 1.01 }}
                              whileTap={{ scale: 0.99 }}
                            >
                            <Reveal delay={0.2}>                              
                              <ExposeCard
                                key={estate.id}
                                id={estate.id}
                                className={`h-fit rounded-xl overflow-hidden text-[110%] shadow-md transition-all bg-white border-none ${estate.id === focusedEstateId ? "ring-prime-700 ring scale-[1.03] shadow-md" : "border-transparent"} ${index === estates.length - 1 ? "pb-40" : ""}`}
                                image={
                                  estate.images && estate.images.length > 0
                                    ? estate.images[0].medium
                                    : "Haus.jpeg"
                                }
                                price={estate.price}
                                base_rent={estate.base_rent}
                                marketing_type={estate.marketing_type}
                                location={`${estate.zip_code}, ${estate.city}`}
                                details={`${estate.number_of_rooms} Zimmer, ${estate.living_space} m²`}
                                description={estate.title}
                                onClick={() =>
                                  handleEstateClickOnMap(estate.id)
                                }
                                isFavorited={favorites.some(
                                  (fav) => fav.id === estate.id
                                )}
                                onFavoriteToggle={() =>
                                  handleFavoriteToggle(estate)
                                }
                              />
                                      </Reveal>
                              
                            </motion.div>
                          </motion.div>
                        )
                    )}
              </div>
            </ScrollArea>
          )}
        </div>
        <AnimatePresence mode="wait">
             <motion.div
             variants={variants}
               animate="visible"
               initial="hidden"
               transition={{ duration: 0.5 }}
               className={` overflow-hidden md:w-10/12 w-full flex-shrink relative ${!showMap ? 'hidden md:block' : 'block'} h-[calc(100vh-12.8rem)] md:h-[calc(100vh-11.1rem)]`}
             >
               <Map
                 className="overflow-hidden h-full w-full"
                 estates={estates}
               />
             </motion.div>
         
        </AnimatePresence>
      </div>
    </div>
  );
}
